<div class="grid h-full grid-rows-[auto_auto_1fr] gap-4">
  <div
    class="animate-slideInUp z-10 flex w-full flex-col gap-y-2"
    style="animation-delay: 100ms"
  >
    <shared-list-title
      title="Commission Payments"
      [isLoading]="store.isLoading()"
    />

    <div class="flex flex-col justify-between gap-3 lg:flex-row">
      <div
        class="flex flex-col items-stretch gap-3 md:flex-row md:flex-wrap md:items-center"
      >
        <lib-date-range
          [dateRange]="store.selectedDateRange()"
          (fromDateChange)="onFromDateChange($event)"
          (toDateChange)="onToDateChange($event)"
        />

        <lib-refresh-button
          [showText]="false"
          [disabled]="store.isLoading()"
          (refreshClick)="onRefresh()"
        />
      </div>

      <div class="flex items-center gap-2">
        <lib-filter-button
          [hasActiveFilters]="filterDisplayStore.hasActiveFilters()"
          (buttonClick)="onOpenFilterDialog()"
        />
      </div>
    </div>
  </div>

  <div class="flex flex-col gap-4">
    <div
      class="flex flex-wrap items-start gap-3 md:items-center md:justify-between"
    >
      <div class="flex-shrink-0">
        <lib-paginator-with-load-more
          [loaded]="store.payments().length"
          [total]="store.total()"
          (loadMore)="onLoadMore()"
        />
      </div>

      @if (filterDisplayStore.hasActiveFilters()) {
      <div
        class="flex min-w-0 flex-1 flex-wrap items-center justify-start gap-2 md:justify-end"
      >
        @for (pill of filterDisplayStore.activeFilterPills(); track pill.key) {
        <lib-pill-with-cancel
          [label]="pill.label"
          [ariaLabel]="'Clear ' + pill.label + ' filter'"
          (clear)="onClearFilterPill(pill)"
        />
        }

        <button
          type="button"
          class="inline-flex items-center rounded-full border border-gray-300 bg-white px-3 py-1 text-sm font-medium text-gray-600 transition-colors hover:border-orange-300 hover:text-orange-700"
          (click)="onClearAllFilterPills()"
        >
          Clear all
        </button>
      </div>
      }
    </div>

    @if (store.error()) {
    <lib-error-alert [error]="store.error()" />
    }
  </div>

  <div class="min-h-0 w-full animate-slideInUp" style="animation-delay: 300ms">
    <lib-commission-payment-list-table
      [payments]="store.payments()"
      [canView]="canView()"
      [sortBy]="store.sortBy()"
      [sortDirection]="store.sortDirection()"
      (viewPayment)="handleViewPayment($event)"
      (sortChange)="onSortChange($event)"
    />
  </div>
</div>

<lib-commission-payment-filter-dialog
  (dialogCancel)="onCloseFilterDialog()"
  (apply)="onFiltersApply()"
/>
